import { FC } from 'react';

import { SearchType } from '@/components/search/types';
import { ChipButton } from '@/components/UI/ChipButton/ChipButton';

import styles from './SearchTypeButtons.module.css';

type SearchTypeButtonsProps = {
  setChipInsideInput: (searchType: SearchType) => void;
  showJSONChip: boolean;
  isWithinAdvancedSearch: boolean;
};
const SearchTypeButtons: FC<SearchTypeButtonsProps> = ({
  setChipInsideInput,
  isWithinAdvancedSearch,
  showJSONChip,
}) => {
  return (
    <div className={styles.chipButtonContainerStyle}>
      <ChipButton
        size='medium'
        testid='trainAndRollingStock-number-chip'
        onClick={() => setChipInsideInput('trainAndRollingStock')}
        label='Trein / Eenheid'
      />
      <ChipButton size='medium' testid='train-number-chip' onClick={() => setChipInsideInput('train')} label='Trein' />
      <ChipButton
        size='medium'
        testid='rollingStock-number-chip'
        onClick={() => setChipInsideInput('rollingStock')}
        label='Eenheid'
      />
      {!isWithinAdvancedSearch && (
        <ChipButton
          size='medium'
          testid='rollingStockType-number-chip'
          label='Materieeltype'
          onClick={() => setChipInsideInput('rollingStockType')}
        />
      )}
      <ChipButton
        size='medium'
        testid='omloop-number-chip'
        label='Omloop'
        onClick={() => setChipInsideInput('omloop')}
      />
      <ChipButton
        size='medium'
        testid='bijzonderheidscode-number-chip'
        label='Bijzonderheidscode'
        onClick={() => setChipInsideInput('bijzonderheidscode')}
      />
      {showJSONChip && (
        <ChipButton size='medium' testid='json-number-chip' label='JSON' onClick={() => setChipInsideInput('json')} />
      )}
    </div>
  );
};
export default SearchTypeButtons;
